/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { forwardRef, useMemo, type Ref } from 'react';
import type { ButtonMenuItemProps } from '@atlaskit/side-nav-items/button-menu-item';
import { useIntl, defineMessage } from '@atlassian/jira-intl';

import { ModalEntryPointPressableTrigger } from '@atlassian/jira-modal-entry-point-pressable-trigger/src/ModalEntryPointPressableTrigger.tsx';
import { CustomisableSidebarModalEntrypoint } from '@jira/navigation-apps__sidebar-nav4-customization-modal/src/CustomisableSidebarModalEntrypoint.entrypoint.tsx';
import type { CustomizableMenuItemData } from '@atlassian/customization-modal/types';
import { CustomizeSidebarMenuItem } from '../customize-sidebar-menu-item/index.tsx';

const customizeSidebar = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.customize-sidebar-menu-item.customize-sidebar',
	// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
	defaultMessage: 'Customize sidebar',
	description: 'Button text to open customization dialog',
});

type JiraCustomizationModalProps = Partial<ButtonMenuItemProps> & {
	productItemsData: CustomizableMenuItemData[];
	appItemsData: CustomizableMenuItemData[];
};

export const CustomizeSidebar: React.ForwardRefExoticComponent<
	Partial<ButtonMenuItemProps> & {
		productItemsData: CustomizableMenuItemData[];
		appItemsData: CustomizableMenuItemData[];
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} & React.RefAttributes<any>
> = forwardRef(CustomizeSidebarInner);

export function CustomizeSidebarInner(
	{ productItemsData, appItemsData, ...props }: JiraCustomizationModalProps,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	buttonRef: React.Ref<any>,
): React.JSX.Element {
	const entryPointParams = useMemo(
		() => ({
			productItemsData,
			appItemsData,
		}),
		[productItemsData, appItemsData],
	);

	const { formatMessage } = useIntl();

	return (
		<ModalEntryPointPressableTrigger
			entryPoint={CustomisableSidebarModalEntrypoint}
			entryPointProps={entryPointParams}
			title={formatMessage(customizeSidebar)}
			useInternalModal={false}
		>
			{}
			{({ ref }) => {
				return (
					// oxlint-disable-next-line typescript/consistent-type-assertions
					<CustomizeSidebarMenuItem {...props} ref={(ref as Ref<HTMLButtonElement>) || buttonRef} />
				);
			}}
		</ModalEntryPointPressableTrigger>
	);
}
